import { useState } from "react";

import "./update-password.css";
import { Button } from "@/components/button";
import { InputText } from "@/components/input-text";

interface UpdatePasswordProps {
    description?: string;
    title?: string; 
    onClick: (password: string, email?: string) => void;
}

const UpdatePassword = ({description, title, ...props}: UpdatePasswordProps) => {

    
    
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const onSubmit = async (e) => {

        e.preventDefault();
        setError("");
        const form = e.target;
        const formData = new FormData(form);
        const password = formData.get("password").toString();
        const confirmPassword = formData.get("confirm-password").toString();

        if (password !== confirmPassword) {
            setError("Les mots de passe ne correspondent pas.");
            return;
        }

        if (password.length < 12) {
            setError("Le mot de passe doit contenir au moins 12 caractères.");
            return;
        }
        

        setLoading(true);
        props.onClick(password)
        setLoading(false);

       
    };

    return (
        <>
        <div className="set-password">
            <form
                className="set-password-card"
                onSubmit={onSubmit}
            >
                <h1>{title}</h1>
                <p>
                    {description}
                </p>
                    <InputText
                        label={"Nouveau mot de passe"} 
                        name={"password"} 
                        placeholder={"Mot de passe"}
                        password={true}
                    />
                    <InputText
                        label={"Confirmation"} 
                        name={"confirm-password"} 
                        placeholder={"Confirmation"}
                        password={true}
                    />
                {error && (
                    <span className="error">
                        {error}
                    </span>
                )}
                <Button
                label={loading
                    ? "Création..."
                    : "Créer mon mot de passe"}
                    type="submit"
                >      
                </Button>
            </form>
        </div>
        </>
    );
};

export default UpdatePassword